exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-label[data-v-96118a04] {\n  display: flex;\n  align-items: center;\n}\n.radio-label input[data-v-96118a04] {\n  margin-top: 0;\n  margin-right: 10px;\n}\n", ""]);

// exports
